module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAHlBMVEX///+uHCghRovKysr9/P27xtvmub0nS44KMn+lBBE43oT/AAABAUlEQVR42u3avUkDYBhF4Q8ygbiBLqDG31o3ECcQXMDCAWzsrbJtIJngVHkhzzPB4dZ3bUdatxcDXcqSdSSrkFXIKmQVsgpZhaxCViGrkFXIKmQVsgpZhaxCViGrkFXIKmQVsgpZhazifLJedgP9r8evgT7XzRpos+7fBnqdupYsWQeyClmFrEJWIauQVcgqZBWyClmFrEJWIauQVcgqZBWyClmFrEJWIauQVcgqZBWyClmFrEJW4pF0Spv18DHQ+3r+G+h3Pf0M9L3urga6liXrSFYhq5BVyCpkFbIKWYWsQlYhq5BVyCpkFbIKWYWsQlYhq5BVyCpkFbKK88najrQHDvLn4bwUv9sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/21.png
// module id = h5m2
// module chunks = 1